import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { setCompanyFailed, setCompanySuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* setCompany(action) {
  try {
    const pool = {
      company_id: action.payload,
    };
    const url = `${BACKEND_URL}/profile/set-company`;
    const response = yield makeRequest(url, pool, action, 'POST');
    const data = yield getBodyJson(response);
    if (response?.status === OK) {
      yield put(setCompanySuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(setCompanyFailed(data));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(setCompanyFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
